import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import ListContext from './ListContext';
import styles from './ListItemMeta.styles';

const ListItemMeta = React.forwardRef(function ListItemMeta(props, ref) {
  const {
    children,
    classes,
    className,
    disableTypography = false,
    inset = false,
    primary: primaryProp,
    primaryTypographyProps,
    secondary: secondaryProp,
    secondaryTypographyProps,
    ...other
  } = props;
  const { dense } = React.useContext(ListContext);

  let primary = primaryProp != null ? primaryProp : children;
  if (primary != null && primary.type !== Typography && !disableTypography) {
    primary = (
      <Typography
        variant={dense ? 'body2' : 'body1'}
        className={classes.primary}
        component="span" // eslint-disable-next-line
        {...primaryTypographyProps}
      >
        {primary}
      </Typography>
    );
  }

  let secondary = secondaryProp;
  if (secondary != null && secondary.type !== Typography && !disableTypography) {
    secondary = (
      <Typography
        variant="body2"
        className={classes.secondary}
        color="textSecondary" // eslint-disable-next-line
        {...secondaryTypographyProps}
      >
        {secondary}
      </Typography>
    );
  }

  return (
    <div
      className={cn(
        classes.root,
        {
          [classes.dense]: dense,
          [classes.inset]: inset,
          [classes.multiline]: primary && secondary,
        },
        className,
      )}
      ref={ref} // eslint-disable-next-line
      {...other}
    >
      {primary}
      {secondary}
    </div>
  );
});

/* eslint-disable */
ListItemMeta.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  disableTypography: PropTypes.bool,
  inset: PropTypes.bool,
  primary: PropTypes.node,
  primaryTypographyProps: PropTypes.object,
  secondary: PropTypes.node,
  secondaryTypographyProps: PropTypes.object,
};
/* eslint-enable */

export default withStyles(styles, { name: 'MuiListItemMeta' })(ListItemMeta);
